///paymentrequest/list
export const PAYMENT_REQUEST_LIST = "PAYMENT_REQUEST_LIST";
export const PAYMENT_REQUEST_LIST_SUCCESS = "PAYMENT_REQUEST_LIST_SUCCESS";
export const PAYMENT_REQUEST_LIST_FAIL = "PAYMENT_REQUEST_LIST_FAIL";
///paymentrequest/preview
export const PAYMENT_REQUEST_PREVIEW = "PAYMENT_REQUEST_PREVIEW";
export const PAYMENT_REQUEST_PREVIEW_SUCCESS = "PAYMENT_REQUEST_PREVIEW_SUCCESS";
export const PAYMENT_REQUEST_PREVIEW_FAIL = "PAYMENT_REQUEST_PREVIEW_FAIL";
///paymentrequest/predicted
export const PAYMENT_REQUEST_PREDICTED = "PAYMENT_REQUEST_PREDICTED";
export const PAYMENT_REQUEST_PREDICTED_SUCCESS = "PAYMENT_REQUEST_PREDICTED_SUCCESS";
export const PAYMENT_REQUEST_PREDICTED_FAIL = "PAYMENT_REQUEST_PREDICTED_FAIL";
///paymentrequest/uncollectable
export const PAYMENT_REQUEST_UNCOLLECTABLE = "PAYMENT_REQUEST_UNCOLLECTABLE";
export const PAYMENT_REQUEST_UNCOLLECTABLE_SUCCESS = "PAYMENT_REQUEST_UNCOLLECTABLE_SUCCESS";
export const PAYMENT_REQUEST_UNCOLLECTABLE_FAIL = "PAYMENT_REQUEST_UNCOLLECTABLE_FAIL";
///paymentrequest/data
export const PAYMENT_REQUEST_DATA = "PAYMENT_REQUEST_DATA";
export const PAYMENT_REQUEST_DATA_SUCCESS = "PAYMENT_REQUEST_DATA_SUCCESS";
export const PAYMENT_REQUEST_DATA_FAIL = "PAYMENT_REQUEST_DATA_FAIL";
///paymentrequest/create
export const PAYMENT_REQUEST_CREATE = "PAYMENT_REQUEST_CREATE";
export const PAYMENT_REQUEST_CREATE_SUCCESS = "PAYMENT_REQUEST_CREATE_SUCCESS";
export const PAYMENT_REQUEST_CREATE_FAIL = "PAYMENT_REQUEST_CREATE_FAIL";
///paymentrequest/search
export const PAYMENT_REQUEST_SEARCH = "PAYMENT_REQUEST_SEARCH";
export const PAYMENT_REQUEST_SEARCH_SUCCESS = "PAYMENT_REQUEST_SEARCH_SUCCESS";
export const PAYMENT_REQUEST_SEARCH_FAIL = "PAYMENT_REQUEST_SEARCH_FAIL";
///paymentrequest/void
export const PAYMENT_REQUEST_VOID = "PAYMENT_REQUEST_VOID";
export const PAYMENT_REQUEST_VOID_SUCCESS = "PAYMENT_REQUEST_VOID_SUCCESS";
export const PAYMENT_REQUEST_VOID_FAIL = "PAYMENT_REQUEST_VOID_FAIL";
